import styled from "styled-components";
import { ActionCardThemeType } from "../../types";

type ActionCardStylesProps = {
  styles: ActionCardThemeType;
};

export const Container = styled.div<ActionCardStylesProps>`
  &:hover {
    cursor: ${(props) => (props.onClick ? "pointer" : "")};
  }
  width: auto;
  padding: 0.5rem 1rem;
  border: ${(props) => props.styles.border};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.styles.background};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: end;
`;
